import { render, staticRenderFns } from "./unread_chats.vue?vue&type=template&id=359109b3&"
import script from "./unread_chats.vue?vue&type=script&lang=js&"
export * from "./unread_chats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports